/** @format */

import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Directive, ElementRef, PLATFORM_ID, Input, inject } from '@angular/core';

@Directive({
  selector: '[homeUtilsAppRunScripts]',
  standalone: false,
})
export class RunScriptsDirective implements AfterViewInit {
  @Input() tagSectionNum: any;
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('attr.data-sectionnum') srcAttr: string;

  private readonly elementRef = inject(ElementRef);
  private readonly platformId = inject(PLATFORM_ID);

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.reinsertScripts();
    }
  }

  reinsertScripts(): void {
    const scripts = this.elementRef.nativeElement.getElementsByTagName(
      'script',
    ) as HTMLScriptElement[];
    const scriptsInitialLength = scripts.length;
    for (let i = 0; i < scriptsInitialLength; i++) {
      if (
        window.document.getElementById(`iliad-replacement-script-${this.srcAttr}-${i}`) === null
      ) {
        const script = scripts[i];

        const scriptCopy = document.createElement('script') as HTMLScriptElement;
        scriptCopy.id = script.id || `iliad-replacement-script-${this.srcAttr}-${i}`;
        scriptCopy.type =
          script.type && script.type !== 'iliad/blocked' ? script.type : 'application/javascript';
        if (script.src) {
          scriptCopy.src = script.src;
        } else if (script.innerHTML) {
          scriptCopy.innerHTML = script.innerHTML;
        }
        scriptCopy.async = false;
        script.parentNode.replaceChild(scriptCopy, script);
      }
    }
  }
}
